import type { ChangeEvent } from "react";
import type { ColorChangeHandler } from "react-color";

export const useColorPickerBottomModal = (setColor: (color: string) => void) => {
    const onChange: ColorChangeHandler = (color) => {
        setColor(color.hex);
    };

    function onInput(e: ChangeEvent<HTMLInputElement>) {
        let value = e.target.value;
        if (value[0] !== "#") value = `#${value}`;
        value = value.slice(0, 7);
        setColor(value);
    }

    return { onChange, onInput };
};
